export { MobileTabBar } from './MobileTabBar';
export type { MobileTabBarProps, MobileTabItem } from './MobileTabBar.types';
